<button kendoButton (click)="keyPressed()">
   <span samwebAutoFitFontSize>
      {{ key }}
   </span>
</button>
